<div class="subtask-form-grid" id="task_mgmt_id">

  <!-- Delete button (top-right) -->
  <div class="subtask-form-delete-row" *ngIf="canEdit">
    <button mat-icon-button class="subtask-remove-btn" type="button" (click)="onRemove()">
      <mat-icon>delete_outline</mat-icon>
    </button>
  </div>

  <!-- Row 1: Subtask Name / Case Type / Assign To -->
  <div class="d-flex mt-2 flex-wrap">
    <div class="col-12 col-md-4 px-md-1 mb-2 mb-md-0">
      <mat-label>Child Case Name</mat-label>
      <input class="subtask-name-input full-width" placeholder="Child Case name" [value]="subtask.name"
        [disabled]="!canEdit" (input)="onFieldChange('name', $any($event.target).value)" />
    </div>

    <div class="col-12 col-md-4 px-md-1 mb-2 mb-md-0">
      <mat-label>Case Type</mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [value]="subtask.taskType" [disabled]="!canEdit"
          (selectionChange)="onFieldChange('taskType', $event.value)">
          <mat-option value="">None</mat-option>
          <mat-option *ngFor="let t of taskTypeOptions" [value]="t.value">
            {{ t.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4 px-md-1">
        <mat-label>Assign To</mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [value]="subtask.assignTo" [disabled]="!canEdit"
          (selectionChange)="onFieldChange('assignTo', $event.value)">
          <mat-option value="">Unassigned</mat-option>
          <mat-option *ngFor="let a of assignToOptions" [value]="a.value">
            {{ a.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Row 2: Start Date / End Date / Remind Me -->
  <div class="d-flex mt-2 flex-wrap">
    <div class="col-12 col-md-4 px-md-1 mb-2 mb-md-0">
      <mat-label>Start Date</mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput [matDatepicker]="stStartPicker" [value]="subtask.startDate" placeholder="Start"
          [disabled]="!canEdit" (dateChange)="onFieldChange('startDate', $event.value)">
        <mat-datepicker-toggle matSuffix [for]="stStartPicker"></mat-datepicker-toggle>
        <mat-datepicker #stStartPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4 px-md-1 mb-2 mb-md-0">
      <mat-label>End Date</mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput [matDatepicker]="stEndPicker" [value]="subtask.endDate" placeholder="End" [disabled]="!canEdit"
          (dateChange)="onFieldChange('endDate', $event.value)">
        <mat-datepicker-toggle matSuffix [for]="stEndPicker"></mat-datepicker-toggle>
        <mat-datepicker #stEndPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4 px-md-1">
      <div class="subtask-remind-label-row">
        <mat-label>Remind Me</mat-label>
        <mat-slide-toggle [checked]="subtask.remindMe" [disabled]="!canEdit"
          (change)="onRemindMeChange($event.checked)">
        </mat-slide-toggle>
      </div>

      <ng-container *ngIf="subtask.remindMe">
        <input type="datetime-local" class="remind-datetime-input" [value]="getRemindDateTimeStr()"
          [disabled]="!canEdit" (change)="onRemindDateTimeInputChange($any($event.target).value)">
      </ng-container>
    </div>
  </div>

  <!-- Row 3: Status / Priority / Tag Type -->
  <div class="d-flex mt-2 flex-wrap">
    <div class="col-12 col-md-4 px-md-1 mb-2 mb-md-0">
      <mat-label>Status</mat-label>
      <mat-form-field appearance="outline" class="full-width scraii-task-mgmt-dialog-status-pill-field">
        <mat-select [value]="subtask.status" [disabled]="!canEdit"
          (selectionChange)="onFieldChange('status', $event.value)">
          <mat-select-trigger>
            <span class="subtask-status-dot" [ngClass]="subtask.status"></span>
            {{ getStatusLabel(subtask.status) }}
          </mat-select-trigger>
          <mat-option *ngFor="let s of statusOptions" [value]="s.value">
            <span class="subtask-status-dot" [ngClass]="s.value"></span>
            {{ s.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4 px-md-1 mb-2 mb-md-0">
      <mat-label>Priority</mat-label>
      <mat-form-field appearance="outline" class="full-width scraii-task-mgmt-dialog-priority-pill-field">
        <mat-select [value]="subtask.priorityLevel" [disabled]="!canEdit"
          (selectionChange)="onFieldChange('priorityLevel', $event.value)">
          <mat-select-trigger>
            <span class="subtask-priority-dot" [ngClass]="subtask.priorityLevel"></span>
            {{ getPriorityLabel(subtask.priorityLevel) }}
          </mat-select-trigger>
          <mat-option *ngFor="let p of priorityLevelOptions" [value]="p.value">
            <span class="subtask-priority-dot" [ngClass]="p.value"></span>
            {{ p.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4 px-md-1">
      <mat-label>Tag Type</mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [value]="subtask.tagType" [disabled]="!canEdit"
          (selectionChange)="onFieldChange('tagType', $event.value)">
          <mat-option value="">None</mat-option>
          <mat-option *ngFor="let t of tagTypeOptions" [value]="t.value">
            {{ t.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Row 4: Tags -->
  <div class="d-flex mt-2 flex-wrap">
    <div class="col-12 px-md-1">
      <span class="d-flex justify-content-between">
        <mat-label>Tags</mat-label>
        <span class="subtask-adv-search-toggle" *ngIf="canEdit && subtask.tagType" (click)="toggleAdvancedSearch()">
          <mat-icon svgIcon="g_filter" class="iconForAdvancedSearch"></mat-icon>
          {{ advancedSearchOpen ? 'Normal Search' : 'Advanced Search' }}
        </span>
      </span>

      <!-- Normal ng-select -->
      <ng-container *ngIf="!advancedSearchOpen">
        <ng-select [items]="tagItems" [ngModel]="subtask.tags" bindLabel="name" bindValue="id" [multiple]="true"
          [virtualScroll]="true" [typeahead]="tagSearch$" (scrollToEnd)="onTagScrollEnd()" [loading]="tagLoading"
          [closeOnSelect]="false" [searchable]="true" [disabled]="!canEdit || !subtask.tagType"
          (ngModelChange)="onFieldChange('tags', $event)" dropdownPosition="bottom" class="subtask-tags-select mt-1">
          <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <input type="checkbox" [checked]="item$.selected" />
            {{ item.name }}
          </ng-template>
          <ng-template ng-loading-text>Loading...</ng-template>
          <ng-template ng-no-data-tmp>No tags found</ng-template>
        </ng-select>
      </ng-container>

      <!-- Advanced Search Panel -->
      <div class="adv-search-panel" *ngIf="advancedSearchOpen">

        <!-- Selected chips -->
        <div class="adv-search-chips" *ngIf="selectedTagList.length">
          <span class="adv-search-chip" *ngFor="let tag of selectedTagList">
            {{ tag.name }}
            <mat-icon class="subtask-chip-remove" (click)="removeSelectedTag(tag.id)">close</mat-icon>
          </span>
        </div>

        <!-- Search By dropdown + input -->
        <form [formGroup]="advancedSearchForm" class="adv-search-filters" (ngSubmit)="onAdvancedSearch()">
          <div class="d-flex flex-column">
            <mat-label>Search By</mat-label>
            <mat-form-field appearance="outline" class="adv-search-by-field">
              <mat-select [(value)]="advancedSearchBy">
                <mat-option *ngFor="let opt of currentSearchByOptions" [value]="opt.value">
                  {{ opt.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="d-flex flex-column">
            <mat-label>Search</mat-label>
            <mat-form-field appearance="outline" class="adv-search-text-field">
              <input matInput formControlName="searchText" placeholder="Type to search..."
                (focus)="advancedResultsVisible = true">
            </mat-form-field>
          </div>
        </form>

        <!-- Results grid -->
        <div class="adv-search-results"
          *ngIf="(advancedSearchResults.length || advancedSearchLoading) && advancedResultsVisible">
          <div class="adv-search-grid-header">
            <span class="adv-search-col-check"></span>
            <span *ngFor="let col of currentColumns" class="adv-search-col-dynamic" [style.width]="col.width || 'auto'"
              [style.flex]="col.width ? '0 0 auto' : '1'">
              {{ col.header }}
            </span>
          </div>
          <div class="adv-search-grid-body" (scroll)="onAdvancedResultsScroll($event)">
            <div class="adv-search-grid-row" *ngFor="let item of advancedSearchResults"
              (click)="toggleAdvancedItem(item)" [class.adv-search-row-selected]="isAdvancedItemSelected(item)">
              <span class="adv-search-col-check">
                <mat-checkbox [checked]="isAdvancedItemSelected(item)" (click)="$event.stopPropagation()"
                  (change)="toggleAdvancedItem(item)">
                </mat-checkbox>
              </span>
              <span *ngFor="let col of currentColumns" class="adv-search-col-dynamic"
                [style.width]="col.width || 'auto'" [style.flex]="col.width ? '0 0 auto' : '1'">
                {{ $any(item)[col.field] }}
              </span>
            </div>
            <div class="adv-search-loading" *ngIf="advancedSearchLoading">
              Loading...
            </div>
          </div>
        </div>

        <!-- No results -->
        <div class="adv-search-no-results"
          *ngIf="advancedSearchPerformed && !advancedSearchResults.length && !advancedSearchLoading && advancedResultsVisible">
          No results found
        </div>
      </div>
    </div>
  </div>

  <!-- Row 5: Attachments -->
  <div class="d-flex mt-2 flex-wrap" *ngIf="canEdit || subtask.attachments?.length">
    <div class="col-12 px-md-1">
      <mat-label>Attachments</mat-label>
      <div class="subtask-attachment-area" *ngIf="canEdit">
        <button type="button" class="subtask-attach-trigger" (click)="subtaskAttachInput.click()">
          Add Files <mat-icon>attach_file</mat-icon>
        </button>
        <input #subtaskAttachInput type="file" hidden multiple (change)="onAttachmentsSelected($event)">
      </div>
      <div class="subtask-attachment-chips" *ngIf="subtask.attachments?.length">
        <span class="subtask-attachment-chip" *ngFor="let file of subtask.attachments; let i = index">
          {{ file.name }}
          <mat-icon class="subtask-chip-remove" *ngIf="canEdit" (click)="removeAttachment(i)">close</mat-icon>
        </span>
      </div>
    </div>
  </div>

  <!-- Row 6: Description -->
  <div class="d-flex mt-2">
    <div class="col-12 px-md-1">
      <mat-label>Description</mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <textarea matInput rows="3" [value]="subtask.description" [disabled]="!canEdit"
          placeholder="Subtask description..."
          (input)="onFieldChange('description', $any($event.target).value)"></textarea>
      </mat-form-field>
    </div>
  </div>

</div>